import dayjs from "dayjs";
import {
  OccupancyData,
  SchedulerProjectData,
  TimeUnits,
  ZoomLevel,
} from "./../types/global";
import { getDuration } from "./getDuration";
import { getTotalHoursAndMinutes } from "./getTotalHoursAndMinutes";
import { getTimeOccupancy } from "./getTimeOccupancy";
import { IHoliday } from "../../@types/holiday.type";
import { getIsHoliday } from "./dates";

export const getMonthOccupancy = (
  occupancy: SchedulerProjectData[],
  focusedDate: dayjs.Dayjs,
  zoom: ZoomLevel,
  listHolidays: IHoliday[],
  dismissedDate?: string | null
): OccupancyData => {
  const focusedMonth = focusedDate.month();

  const calculateBusinessDays = (
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    holidays: string[] = []
  ) => {
    // return endDate.startOf("day").diff(startDate.startOf("day"), "day")

    let current = startDate.startOf("day");
    const end = endDate.startOf("day");
    let businessDays = 0;

    while (!current.isAfter(end)) {
      const dayOfWeek = current.day();
      if (
        dayOfWeek !== 0 &&
        dayOfWeek !== 6 &&
        !holidays.includes(current.format("YYYY-MM-DD"))
      ) {
        businessDays++;
      }
      current = current.add(1, "day");
    }
    return Math.max(0, businessDays);
  };

  const uniqueOccupancy = [];
  const seenIds = new Set();

  for (const item of occupancy) {
    if (!seenIds.has(item.id)) {
      seenIds.add(item.id);
      uniqueOccupancy.push(item);
    }
  }

  function getHoursAndMinutes(
    uniqueOccupancy: SchedulerProjectData[]
  ): TimeUnits[] {
    return uniqueOccupancy.map((item) => {
      const itemStart = dayjs(item.startDate);
      const itemEnd = dayjs(item.endDate);
      const itemMonthStart = itemStart.month();
      const itemMonthEnd = itemEnd.month();

      const { hours: itemHours, minutes: itemMinutes } = getDuration(
        Math.round(item.hoursPerDay) * 60 * 60
      );

      // if(!item.isProject) {
      //   return { hours: 0, minutes: 0 };
      // }

      let differenceinWorkingDays;

      if (focusedMonth === itemMonthStart && focusedMonth === itemMonthEnd) {
        differenceinWorkingDays = calculateBusinessDays(itemStart, itemEnd);
      } else if (
        focusedMonth === itemMonthStart &&
        focusedMonth !== itemMonthEnd
      ) {
        differenceinWorkingDays = calculateBusinessDays(
          itemStart,
          focusedDate.endOf("month")
        );
      } else if (
        focusedMonth !== itemMonthStart &&
        focusedMonth === itemMonthEnd
      ) {
        differenceinWorkingDays = calculateBusinessDays(focusedDate, itemEnd);
      } else {
        differenceinWorkingDays = calculateBusinessDays(
          focusedDate,
          focusedDate.endOf("month")
        );
      }

      differenceinWorkingDays =
        differenceinWorkingDays > 21 ? 21 : differenceinWorkingDays;

      return {
        hours: differenceinWorkingDays * itemHours,
        minutes: differenceinWorkingDays * itemMinutes,
      };
    });
  }

  const allocationOcupancy: SchedulerProjectData[] = [];
  const allocationGroupOcupancy: SchedulerProjectData[] = [];
  const unavailabilityOcupancy: SchedulerProjectData[] = [];
  const projectionOcupancy: SchedulerProjectData[] = [];

  for (const item of uniqueOccupancy) {
    if (item.isProjection) projectionOcupancy.push(item);
    else if (!item.isProject) unavailabilityOcupancy.push(item);
    else if (item.linkId) allocationGroupOcupancy.push(item);
    else allocationOcupancy.push(item);
  }

  const { hours: totalHours, minutes: totalMinutes } = getTotalHoursAndMinutes(
    getHoursAndMinutes(uniqueOccupancy)
  );
  const { free, overtime } = getTimeOccupancy(
    { hours: totalHours, minutes: totalMinutes },
    zoom,
    focusedDate,
    dismissedDate
  );

  return {
    taken: {
      hours: Math.max(0, totalHours),
      minutes: Math.max(0, totalMinutes),
    },
    free,
    overtime,
    allocation: allocationOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationOcupancy))
      : { hours: 0, minutes: 0 },
    allocationGroup: allocationGroupOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(allocationGroupOcupancy))
      : { hours: 0, minutes: 0 },
    unavailability: unavailabilityOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(unavailabilityOcupancy))
      : { hours: 0, minutes: 0 },
    projection: projectionOcupancy.length
      ? getTotalHoursAndMinutes(getHoursAndMinutes(projectionOcupancy))
      : { hours: 0, minutes: 0 },
  };
};
